import * as m from "@paraglide/messages"
import type { ContactFormData } from "@site-types/send-mail"
import type { UseFormSetValue } from "react-hook-form"
import { FormSelect } from "../FormSelect"
import { useSendMailLang } from "../lang-context"

type RecruitmentSelectionProps = {
  value: string
  setValue: UseFormSetValue<ContactFormData>
  careerList: string[]
}

export const RecruitmentSelection = ({ value, setValue, careerList }: RecruitmentSelectionProps) => {
  const lang = useSendMailLang()

  const options = [...careerList, m.contact_formPosition_others({}, { locale: lang })]

  return (
    <div className="relative mb-8 flex flex-col">
      <label
        className="py-4"
        htmlFor="form-position-list"
      >
        {m.contact_formPosition_label({}, { locale: lang })} {m.contact_form_required({}, { locale: lang })}
      </label>
      <FormSelect
        id="form-position-list"
        name="position"
        value={value}
        onValueChange={(next) => setValue("position", next, { shouldValidate: true, shouldDirty: true })}
        options={options}
        required
      />
    </div>
  )
}
